import { render } from "./IndustrySection.vue?vue&type=template&id=2284b5f2&scoped=true"
import script from "./IndustrySection.vue?vue&type=script&lang=js"
export * from "./IndustrySection.vue?vue&type=script&lang=js"

import "./IndustrySection.vue?vue&type=style&index=0&id=2284b5f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2284b5f2"]])

export default __exports__